/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { mobileOrderCreateRequestSchema } from "./mobileOrderCreateRequestSchema.ts";
import { mobileOrderResponseSchema } from "./mobileOrderResponseSchema.ts";

export const orgUnitDeviceOrderCreateCreatePathOrgUnitIdSchema = z.uuid();

export const orgUnitDeviceOrderCreateCreateStatus201Schema = mobileOrderResponseSchema;

export const orgUnitDeviceOrderCreateCreateResponseSchema = orgUnitDeviceOrderCreateCreateStatus201Schema;

export const orgUnitDeviceOrderCreateCreateDataSchemaJson = mobileOrderCreateRequestSchema.optional();

export const orgUnitDeviceOrderCreateCreateDataSchemaXml = mobileOrderCreateRequestSchema.optional();

export const orgUnitDeviceOrderCreateCreateDataSchema = z.union([orgUnitDeviceOrderCreateCreateDataSchemaJson, orgUnitDeviceOrderCreateCreateDataSchemaXml]);
